import { render, staticRenderFns } from "./LojaRepresentantes.vue?vue&type=template&id=3b1d0f80&scoped=true"
import script from "./LojaRepresentantes.vue?vue&type=script&lang=js"
export * from "./LojaRepresentantes.vue?vue&type=script&lang=js"
import style0 from "./LojaRepresentantes.vue?vue&type=style&index=0&id=3b1d0f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d0f80",
  null
  
)

export default component.exports